export const wrapText = (text, maxWidth, fontSize, font) => {
  const words = text.split(" ");
  const lines = [];
  let currentLine = "";

  words.forEach((word) => {
    const testLine = currentLine ? `${currentLine} ${word}` : word;
    const testWidth = font.widthOfTextAtSize(testLine, fontSize);

    if (testWidth < maxWidth) {
      currentLine = testLine;
    } else {
      lines.push(currentLine);
      currentLine = word;
    }
  });

  lines.push(currentLine);
  return lines;
};

export const getSupportedFileExts = (fileType) => {
  switch (fileType) {
    case "Image": {
      return ".jp,.jpeg,.png";
    }
    case "Documents": {
      return ".pdf";
    }
    case "Video": {
      return ".mp4,.mov,.wmv,.avi,.mkv,.webm,.html5,.mpeg";
    }
  }
};

const compareStrings = (a, b) => {
  a = a.toLowerCase();
  b = b.toLowerCase();
  return a < b ? -1 : a > b ? 1 : 0;
};

export const getEventTypeOptions = () => {
  return [
    { value: 1, label: "Presentation" },
    { value: 2, label: "Roundtable" },
    { value: 3, label: "Workshop" },
    { value: 4, label: "Town Hall" },
    { value: 5, label: "One-on-One" },
    { value: 6, label: "Demo" },
    { value: 7, label: "Meet & Greet" },
    { value: 8, label: "Hi-Tea" },
    { value: 9, label: "Lunch" },
    { value: 10, label: "Dinner" },
    { value: 11, label: "Introduction" },
    { value: 12, label: "Welcome" },
    { value: 13, label: "Hackathon" },
    { value: 14, label: "Floor Walk" },
    { value: 15, label: "Team Event" },
    { value: 16, label: "Break" },
    { value: 17, label: "Client Address" },
    { value: 18, label: "Wrap-up" },
    { value: 19, label: "Next Steps" },
    { value: 20, label: "Overview" },
    { value: 21, label: "Brainstorming" },
    { value: 22, label: "Case Study" },
    { value: 23, label: "Leadership Address" },
    { value: 24, label: "De-brief" },
    { value: 25, label: "Facility Tour" },
    { value: 26, label: "City Tour" },
    { value: 27, label: "Badging" },
    { value: 28, label: "Breakout" },
    { value: 29, label: "CSR" },
    { value: 30, label: "Team Meet" },
    { value: 31, label: "Wellness" },
    { value: 32, label: "Working Lunch" },
    { value: 33, label: "Breakfast" },
    { value: 34, label: "Commute" },
    { value: 33, label: "Personal Time" },
    { value: 34, label: "Co-working Time" },
  ].sort((a, b) => compareStrings(a.label, b.label));
};

export const VIDEO = "Video";
export const LINK = "Link";
export const DOCUMENTS = "Documents";
export const IMAGE = "Image";


export const isValidEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
  return re.test(email);
};